// Start of Event Service code
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, interval, Observable, Subject, Subscription } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';

import { ICounter } from '../shared/interfaces/common.interface';
import { WINDOW } from './window';

// Used to store key value pairs
interface Event {
  key: string;
  value: any;
}

@Injectable({
  providedIn: 'root',
})
export class EventService {
  protected eventsSubject = new Subject<Event>();
  public count: number = 0;
  private daysCounter = new BehaviorSubject<ICounter>({ _days: 0, _hours: 0, _minutes: 0, _seconds: 0, _diff: 0 });
  private stopper = new Subject();
  private counter!: Subscription;

  constructor(
    @Inject(WINDOW) private window: Window,
  ) { }

  /*Method is responsible for Broadcast Event */
  public broadcastEvent(key: string, value: any): void {
    this.eventsSubject.next({ key, value });
  }

  /* Method is responsible for Get Event*/
  public getEvent(key: string): Observable<Event> {
    return this.eventsSubject.asObservable().pipe(
      filter((e) => e.key === key),
      map((e) => e.value),
    );
  }

  resetCounter() {
    if (this.counter) this.counter?.unsubscribe();
    this.stopper = new Subject();
    console.log('resetCounter called');
  }

  setCounter(endDate: number) {
    console.log('setCounter =', endDate);
    let _diff: number;
    this.counter = interval(1000)
      .pipe(
        takeUntil(this.stopper),
        map((x) => {
          _diff = endDate - Date.parse(new Date().toString());
        }),
      )
      .subscribe((x) => {
        if (_diff <= 0) {
          this.broadcastEvent('ROUND-END', true);
          this.stopper.next(false);
        } else {
          const object: ICounter = {
            _days: this.getDays(_diff) < 10 ? '0' + this.getDays(_diff) : this.getDays(_diff),
            _hours: this.getHours(_diff) < 10 ? '0' + this.getHours(_diff) : this.getHours(_diff),
            _minutes: this.getMinutes(_diff) < 10 ? '0' + this.getMinutes(_diff) : this.getMinutes(_diff),
            _seconds: this.getSeconds(_diff) < 10 ? '0' + this.getSeconds(_diff) : this.getSeconds(_diff),
            _diff,
          };
          this.daysCounter.next(object);
        }
      });
  }

  getCounter(): Observable<ICounter> {
    return this.daysCounter.asObservable();
  }

  getDays(t: number) {
    return Math.floor(t / (1000 * 60 * 60 * 24));
  }

  getHours(t: number) {
    return Math.floor((t / (1000 * 60 * 60)) % 24);
  }

  getMinutes(t: number) {
    return Math.floor((t / 1000 / 60) % 60);
  }

  getSeconds(t: number) {
    return Math.floor((t / 1000) % 60);
  }

  scrollToFn(section: string) {
    if (this.window) {
      window.location.hash = section;
    }
  }

  showBuyWidget(scrollTo: string = ''): void {
    this.scrollToFn(scrollTo);
  }
}
